import { render, staticRenderFns } from "./GeneralTags.vue?vue&type=template&id=124eac86&lang=pug&"
import script from "./GeneralTags.vue?vue&type=script&lang=js&"
export * from "./GeneralTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports